import React from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import {translateReplacementCarStatus} from "../../utils/translateReplacementCarStatus";

const useStyles = makeStyles(() => ({
    labelInput: {
        fontFamily: "Poppins",
        fontSize: "13px",
        fontWeight: 500,
        textAlign: "left",
        color: "rgba(128, 128, 143, 1)",
    },
    styleInput: {
        borderRadius: "4px",
        height: "36px",
        width: "250px",
        padding: "14px",
        fontFamily: "Poppins",
        fontSize: "12px",
        fontWeight: 400,
        textAlign: "left",
        color: "rgba(70, 78, 95, 1)",
    },
    container: {
        //marginBottom: "10px",
    },
    specialInput: {
        color: "rgba(24, 28, 50, 0.58)",
        height: "28px",
        fontFamily: "Poppins",
        fontSize: "13px",
        fontWeight: 500,
        textAlign: "right",
        border: "none",
        backgroundColor: "rgba(243, 246, 249, 1)",
        width: "209px",
        // marginBottom: "5px"
    },
    generalInput: {
        fontFamily: "Poppins",
        fontSize: "13px",
        fontWeight: 500,
        textAlign: "right",
        color: "rgba(24, 28, 50, 1)",
        border: "none",
        backgroundColor: "rgba(255, 255, 255, 0)",
        width: "209px",
    },
    statusInput: {
        color: "rgba(255, 168, 0, 1)",
        fontFamily: "Poppins",
        fontSize: "13px",
        fontWeight: 500,
        textAlign: "right",
        border: "none",
        width: "209px",
        backgroundColor: "rgba(255, 255, 255, 0)",
    }
}));

const ReglementGarageDialog = ({ payment }) => {
    const classes = useStyles();

    const fields = [
        { label: 'Status', value: translateReplacementCarStatus(payment.status) || "N/A", class: classes.statusInput },
        { label: 'Code garage', value: payment.garageCode || "N/A", class: classes.generalInput },
        { label: 'Montant Pièce', value: payment.partsAmount || "N/A", class: classes.specialInput },
        { label: 'Nombre d\'heures', value: payment.totalHours || "N/A", class: classes.specialInput },
        { label: 'Nombre d\'heures t1', value: payment.hoursT1 || "N/A", class: classes.specialInput },
        { label: 'Nombre d\'heures t2', value: payment.hoursT2 || "N/A", class: classes.specialInput },
        { label: 'Nombre d\'heures peinture', value: payment.paintHours || "N/A", class: classes.specialInput },
        { label: 'Tarif horaire t1', value: payment.hourlyRateT1 || "N/A", class: classes.specialInput },
        { label: 'Tarif horaire t2', value: payment.hourlyRateT2 || "N/A", class: classes.specialInput },
        { label: 'Montant total réparation Sans Tax', value: payment.totalRepairAmountWOTax || "N/A", class: classes.specialInput },
        { label: 'Montant total réparation TTC', value: payment.totalRepairAmountWTax || "N/A", class: classes.specialInput },
        { label: 'Part STAR sans remise TTC', value: payment.starShareWithDiscountWTax || "N/A", class: classes.specialInput },
        { label: 'Part client TTC', value: payment.starShareWODiscountWTax || 'N/A', class: classes.specialInput },
        { label: 'Taux de remise sur les pièces', value: payment.discountRateOnParts || 'N/A', class: classes.specialInput },
        { label: 'Taux de remise sur la main d\'oeuvre', value: payment.discountRateOnLabor || 'N/A', class: classes.specialInput },
    ];

    return (
        <div>
            {fields.map((field, index) => (
                <Grid container className={classes.container} key={index} spacing={2}>
                    <Grid item xs={6} container alignItems='center'>
                        <div className={classes.labelInput}>{field.label}</div>
                    </Grid>
                    <Grid item xs={6} container alignItems='center'>
                        <input className={field.class} type="text" value={field.value} disabled />
                    </Grid>
                </Grid>
            ))}
        </div>
    );
};

export default ReglementGarageDialog;
